import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken, useGetData } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";

export const getScheduleTime = createAsyncThunk(
  "/usersSlice/getScheduleTime",
  async ({ query }, { rejectWithValue }) => {
      try {
          const response = await useGetData(`/api/v1/schedule/times?${query}`);
          console.log('res', response);        

          return response;
      } catch (error) {
          console.log("error", error);

          if (error.message === "Network Error") {
               rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
              return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

          } else if (error?.response?.data?.message) {
              notify(error?.response?.data?.message ,"error")
              return rejectWithValue(error?.response?.data?.message || "An error occurred");
            } else {
               notify("حدث خطأ حاول مرة اخري","error");
              return rejectWithValue("حدث خطأ حاول مرة اخري");
          }
      }
  }
);